import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { Delete, Edit, Search } from '@element-plus/icons-vue'
import chapterApi from "@/api/chapter";
import tablePager from "@/components/table-pager.vue";
import i18n from '@/i18n';
import { reactive } from 'vue';
import { mangaInfoType } from '@/type/manga';
import { onMounted } from 'vue';
import { userConfig } from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props, { expose: __expose }) {
  __expose();

const { t } = i18n.global;
const count = ref(0);
const tableData = ref([]);
const editChapterDialog = ref(false);
const keyWord = ref('');
const form = reactive({
  chapterId: '',
  chapterName: '',
  chapterPath: '',
  chapterCover: '',
})

const formInit = {
  chapterId: '',
  chapterName: '',
  chapterPath: '',
  chapterCover: '',
}

const pager = ref();
/***
 * 关闭弹窗
 */
function dialog_close() {
  editChapterDialog.value = false;
}
/**
 * 开启弹窗
 */
function dialog_open() {
  Object.assign(form, formInit);

  editChapterDialog.value = true;

}

/**
 * 加载表格数据
 */
async function load_table(page = 1, pageSize = 10) {
  const res = await chapterApi.get(0, page, pageSize, userConfig.order, keyWord.value);
  count.value = Number(res.count);
  tableData.value = res.list;
}
/**
 * 重载数据 页码不变
 */
function reload_table() {
  pager.value.reload_page();
}
/**
 * 编辑漫画
 * @param index
 * @param row
 */
function edit_chapter(index: number, mangaInfo: mangaInfoType) {
  dialog_open();
  Object.assign(form, mangaInfo);
}

/**
 * 执行修改请求
 */
async function do_update_chapter() {
  // 表单验证-章节名
  if (!form.chapterName) {
    ElMessage.warning(t('chapterManage.warning.name'));
    return false;
  }
  // 表单验证-章节路径
  if (!form.chapterPath) {
    ElMessage.warning(t('chapterManage.warning.path'));
    return false;
  }

  const res = await chapterApi.update_chapter(form);
  if (res.code === 0) {
    editChapterDialog.value = false;
    reload_table();
  }
}

/**
 * 删除漫画
 * */
async function do_delete_chapter(index: number, row: any) {
  ElMessageBox.confirm(
    t('chapterManage.confirm.text'),
    t('chapterManage.confirm.title'), {
    type: 'warning'
  }).then(async () => {
    const res = await chapterApi.delete_chapter(row.chapterId);

    if (res.code === 0) {
      reload_table();
    }
  }).catch(() => {
  })
}

onMounted(() => {
  load_table();
})

const __returned__ = { t, count, tableData, editChapterDialog, keyWord, form, formInit, pager, dialog_close, dialog_open, load_table, reload_table, edit_chapter, do_update_chapter, do_delete_chapter, get Delete() { return Delete }, get Edit() { return Edit }, get Search() { return Search }, tablePager }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})